import { render, staticRenderFns } from "./InventoryBackImport.vue?vue&type=template&id=0e229d48&scoped=true&"
import script from "./InventoryBackImport.vue?vue&type=script&lang=js&"
export * from "./InventoryBackImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e229d48",
  null
  
)

export default component.exports